import style from './style.scss';
import Button from '../button';

/**
 * The ButtonGroup component renders a collection of Button components
 * given the options provided as props. Only one may be active at any given
 * moment.
 *
 * props:
 * - options: an array of objects, e.g. { value: 1, label: 'Option 1' }
 * - activeOption: the value of the option which is active
 * - onBtnClick: click handler function, called when a button in the group is clicked.
 */

const ButtonGroup = props => {

	return (
		<div class={style.button_group}>
			{
				props.options.map(opt => (
					<div class={style.button_group_option} key={opt.value}>
						<Button isActive={opt.value === props.activeOption}
						        data={opt.value}
						        clickHandler={props.onBtnClick}>
							{ opt.label }
						</Button>
					</div>
				))
			}
		</div>
	);

};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./components/button-group/index.js